import React from "react";
import classNames from 'classnames';
import { ExtensibleFunction } from './extensibleFunction';
/**
 * API-enhancing wrapper class for CSS Module classname maps
 */
export class StyleSheet extends ExtensibleFunction {
    constructor(styles) {
        super((...args) => {
            return this.class(...args);
        });
        if (Object.keys(styles).length == 1 && 'default' in styles) {
            styles = styles.default;
        }
        this.styles = styles;
        Object.assign(this, styles);
    }
    element(classes, type = 'div', globalClass) {
        return styledElement(this.styles, classes, {
            type,
            globals: globalClass,
        });
    }
    class(classes, globalClass) {
        return mClassNames(this.styles, classes, globalClass);
    }
}
/**
 * Wraps a map of local to global style names (generated by CSS Modules) in a more useful API.
 * Same as calling `new StyleSheet(style_map)`.
 */
export function styleSheet(...args) {
    return new StyleSheet(...args);
}
export function extendHTMLElement(classes, Element = 'div') {
    const sfc = React.forwardRef((props, ref) => {
        // @ts-ignore
        return React.createElement(Element, { ref: ref, ...props, className: classNames(props.className, classes) });
    });
    return sfc;
}
export function styledElement(styles, classes, { type = 'div', globals, } = {}) {
    return extendHTMLElement(mClassNames(styles, classes, globals), type);
}
export function moduleClassNames(styles, doubleNames, extraNames) {
    const stylesNames = classNames(doubleNames).split(' ').map(n => styles[n]);
    return classNames(doubleNames, stylesNames, extraNames);
}
export const mClassNames = moduleClassNames;
//# sourceMappingURL=StyleSheet.js.map